"use client"; // useLingui requires client component

import { useLingui } from "@lingui/react/macro";
import { LockIcon } from "lucide-react";

import ErrorPage from "./_components/error-page";

export default function Forbidden() {
  const { t } = useLingui();
  return <ErrorPage code="403" title={t`Forbidden`} icon={LockIcon} />;
}
